import { useEffect, useState } from 'react';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
 
const ShowGrandParent = ({ id, type }) => {
    const [data, setData] = useState({
        nom: '',
        prénom: '',
        naissance: '',
        lieu: ''
    });
 
    useEffect(() => {
        const nom = localStorage.getItem(`lastname${type}${id}`) || '';
        const prénom = localStorage.getItem(`firstname${type}${id}`) || '';
        const naissance = localStorage.getItem(`birthborn${type}${id}`) || '';
        const lieu = localStorage.getItem(`birthplace${type}${id}`) || '';
 
        if (nom || prénom || naissance || lieu) {
            setData({ nom, prénom, naissance, lieu });
        }
    }, [id, type]);
 
    const isEmpty = !data.nom && !data.prénom && !data.naissance && !data.lieu;
    if (isEmpty) return null;
 
    return (
        <div className="max-w-md w-full">
            <div className='p-6 bg-white dark:bg-black flex justify-center'>
                <div className="w-full border border-gray-700 rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
                    <p className='text-2xl font-bold text-black dark:text-white'>{data.nom} <br></br> {data.prénom}</p>
                    <p className='text-2xl font-bold text-black dark:text-white'>{data.naissance}</p>
                    <p className='text-2xl font-bold text-black dark:text-white'>{data.lieu}</p>
                </div>
            </div>
        </div>
    );
};
 
const GreatFather = ({ prénom, id, nom }) => {
    const [lastName, setLastName] = useState(() => localStorage.getItem(`lastnamegp${id}`) || '');
    const [firstName, setFirstName] = useState(() => localStorage.getItem(`firstnamegp${id}`) || '');

    const handleChangeFirstName = (e) => {
        setFirstName(e.target.value);
        localStorage.setItem(`firstnamegp${id}`, e.target.value)
    };
 
    const handleChangeLastName = (e) => {
        const upperCaseValue = e.target.value.toUpperCase();
        setLastName(upperCaseValue);
        setTimeout(() => {
            localStorage.setItem(`lastnamegp${id}`, e.target.value)
        }, 100);
    };

    const fullName = prénom && nom ? `${prénom} ${nom}` : '';

    return (
        <form className='"mx-auto max-w-lg'>
            <div className='p-6 bg-white dark:bg-black flex justify-center'>
                <div className="w-full max-w-md rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
                    <h1 className='text-black dark:text-white text-xl font-semibold mb-4'>Mettez le nom du père de {prénom} {nom}</h1>
                    <div className='mb-4'>
                        <Label className='text-lg font-bold text-black dark:text-white' htmlFor="father-lastname">Nom du père <br></br> de {prénom} {nom}</Label>
                        <Input value={lastName} onChange={handleChangeLastName} type="text" className="w-full" id="father-lastname" placeholder={fullName ? `Entrez le nom du père de ${prénom} ${nom}` :  ''} />
                    </div>
                    <div className='mb-4'>
                        <Label className='text-lg font-bold text-black dark:text-white' htmlFor="father-firstname">Prénom du père <br></br> de {prénom} {nom}</Label>
                        <Input value={firstName} onChange={handleChangeFirstName} type="text" className="w-full" id="father-firstname" placeholder={fullName ? `Entrez le prénom du père de ${prénom} ${nom}` : ''} />
                    </div>
                </div>
            </div>
        </form>
    );
}
 
const GreatMother = ({ prénom, id, nom }) => {
    const [lastName, setLastName] = useState(() => localStorage.getItem(`lastnamegm${id}`) || '');
    const [firstName, setFirstName] = useState(() => localStorage.getItem(`firstnamegm${id}`) || '');
 
    const handleChangeFirstName = (e) => {
        setFirstName(e.target.value);
        localStorage.setItem(`firstnamegm${id}`, e.target.value)
    };
 
    const handleChangeLastName = (e) => {
        const upperCaseValue = e.target.value.toUpperCase();
        setLastName(upperCaseValue);
        setTimeout(() => {
            localStorage.setItem(`lastnamegm${id}`, e.target.value)
        }, 100);
    };

    const fullName = prénom && nom ? `${prénom} ${nom}` : '';

    return (
        <form className='mx-auto max-w-sm'>
            <div className='p-6 bg-white dark:bg-black flex justify-center'>
                <div className="w-full max-w-md rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
                    <h1 className='text-black dark:text-white text-lg font-semibold mb-4'>
                        Mettez le nom de jeune fille de la mère de {prénom} {nom}
                    </h1>
                    <div className='mb-4'>
                        <Label className='text-base font-bold text-black dark:text-white' htmlFor="mother-lastname">Nom de jeune fille de la mère de {prénom} {nom}</Label>
                        <Input value={lastName} onChange={handleChangeLastName} type="text" id="mother-lastname" className="w-full" placeholder={fullName ? `Nom de la mère de ${fullName}`: ''} />
                    </div>
                    <div className='mb-4'>
                        <Label className='text-base font-bold text-black dark:text-white' htmlFor="mother-firstname">Prénom de la mère de {prénom} {nom}</Label>
                        <Input value={firstName} onChange={handleChangeFirstName} type="text" id="mother-firstname" className="w-full" placeholder={fullName ? `Prénom de la mère de ${prénom} ${nom}`: ''} />
                    </div>
                </div>
            </div>
        </form>
    );
};
 
const GrandParentsBranch = ({setParents, setShowGP, setShowParents}) => {
    const [showGrandParents, setShowGrandParents] = useState(true)
    const [showDataGrandParents, setShowDataGrandParents] = useState(false)
    const nomPère = localStorage.getItem('lastnamefather')
    const prénomPère = localStorage.getItem('firstnamefather')
    const nomMère = localStorage.getItem('lastnamemother')
    const prénomMère = localStorage.getItem('firstnamemother')
    const [showModal, setShowModal] = useState(false)
    const [checkAll, setCheckAll] = useState(false);

    const getValue = (key) => (localStorage.getItem(key) || '').trim();

  // Vérifie que tous les champs (nom, prénom, lieu) de chaque grand-parent sont non-vides
  const validateAllFields = () => {
    // Pour le père du père (id="1")
    const gp1LastName   = getValue('lastnamegp1');
    const gp1FirstName  = getValue('firstnamegp1');

    // Pour la mère du père (id="2")
    const gm2LastName   = getValue('lastnamegm2');
    const gm2FirstName  = getValue('firstnamegm2');

    // Pour le père de la mère (id="3")
    const gp3LastName   = getValue('lastnamegp3');
    const gp3FirstName  = getValue('firstnamegp3');

    // Pour la mère de la mère (id="4")
    const gm4LastName   = getValue('lastnamegm4');
    const gm4FirstName  = getValue('firstnamegm4');

    const allFilled =
      gp1LastName   !== '' &&
      gp1FirstName  !== '' &&
      gm2LastName   !== '' &&
      gm2FirstName  !== '' &&
      gp3LastName   !== '' &&
      gp3FirstName  !== '' &&
      gm4LastName   !== '' &&
      gm4FirstName  !== ''

    return allFilled;
  };

  const handleSubmitDataGrandParents = () => {
    if (!validateAllFields()) {
      setCheckAll(true);
      return;
    }

    // Si tout est rempli, on passe à l’affichage des données et on ouvre la modale de confirmation
    setShowGrandParents(false);
    setShowDataGrandParents(true);
    setShowModal(true);

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

 
    return (
        <div>
            {showGrandParents &&
                <div className="flex flex-col items-center justify-center space-y-6 p-10">
                    <div className="flex flex-wrap justify-center  w-full max-w-[1800px] mx-auto">
                        {prénomPère && nomPère && (
                            <>
                                <GreatFather prénom={prénomPère} id="1" nom={nomPère} />
                                <GreatMother prénom={prénomPère} id="2" nom={nomPère} />
                            </>
                        )}
 
                        {prénomMère && nomMère && (
                            <>
                                <GreatFather prénom={prénomMère} id="3" nom={nomMère} />
                                <GreatMother prénom={prénomMère} id="4" nom={nomMère} />
                            </>
                        )}
                    </div>
                    {/* Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 mt-4">
                        <button
                            type="button"
                            onClick={() => {
                                setParents(true);
                                setShowGP(false)
                                setShowParents(false)
                            }}
                            className="py-4 px-8 text-xl font-bold rounded-xl border border-transparent bg-blue-100 text-blue-800 hover:bg-blue-200 dark:text-blue-400 dark:bg-blue-800/30 dark:hover:bg-blue-800/20"
                        >
                            Revenez sur le formulaire précédent
                        </button>
                        <button
                            type="button"
                            onClick={handleSubmitDataGrandParents}
                            className="py-4 px-8 text-xl font-bold rounded-xl border border-transparent bg-green-100 text-green-800 hover:bg-green-200 dark:text-green-400 dark:bg-green-800/30 dark:hover:bg-green-800/20"
                        >
                            Continuer votre arbre
                        </button>
                    </div>
                  {checkAll && <p className='text-lg text-red-500'>Tous les champs doivent être OBLIGATOIREMENT remplis</p>}
                </div>
            }
            {showDataGrandParents &&
                <div className="flex flex-col md:flex-row items-center justify-center gap-6">
                    <div className="w-full md:w-1/2">
                        <ShowGrandParent id="1" type="gp" />
                    </div>
                    <div className="w-full md:w-1/2">
                        <ShowGrandParent id="2" type="gm" />
                    </div>
                    <div className="w-full md:w-1/2">
                        <ShowGrandParent id="3" type="gp" />
                    </div>
                    <div className="w-full md:w-1/2">
                        <ShowGrandParent id="4" type="gm" />
                    </div>
                </div>
            }
            {showModal && (
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-opacity-50 bg-gray-700">
                    <div className="bg-white dark:bg-neutral-900 p-6 rounded-lg shadow-lg w-96 text-center">
                        <h2 className="text-xl font-semibold mb-4 dark:text-white text-black"> Veuillez confirmer que les informations des grands-parents sont exactes.</h2>
                        <div className="flex justify-between">
                            <button
                                onClick={() =>  {
                                    setShowDataGrandParents(false)
                                    setShowGrandParents(true)
                                    setShowModal(false)
                                }
                                }
                                className="py-2 px-4 bg-gray-300 rounded-lg hover:bg-gray-400"
                            >
                                Annuler
                            </button>
                            <button
                                onClick={() => {
                                    setShowModal(false)
                                }}
                                className="py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                            >
                                Confirmer
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
 
export default GrandParentsBranch;